import { Component, OnInit } from '@angular/core';
import { UserDetailsModel, CountriesModel, StatesModel } from '../model/user-profile.modals';
import { AuthService } from '../services/auth.service';
import { UtilityService } from '../services/utility.service';
import { AlertService } from '../services/alert.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {
  id: any;
  title: any = 'Profile';
  userDetails: UserDetailsModel = new UserDetailsModel();
  userName = '';
  isLoading: boolean;
  constructor(
    private authService: AuthService,
    public utilityService: UtilityService,
    private alertService: AlertService
  ) {
    this.id = localStorage.getItem('user_id');
  }
  ngOnInit() {
    this.getUserDetails();
  }
  /**
   * To get logged in Organization user details
   * @memberof UserProfileComponent
   */
  getUserDetails() {
    this.isLoading = true;
    this.authService
      .getOrganizationUserDetails(this.id)
      .subscribe((response: any) => {
        if (!response.error) {
          this.userDetails = response.response;
          this.userName = this.userDetails.username;
          console.log(this.userDetails);
          this.isLoading = false;
        }
      });

  }


}
